import Slider from '../Slider';

export default class Navigation {
  private _slider: Slider;
  private el: HTMLDivElement;
  
  constructor(slider: Slider) {
    this._slider = slider;
    this.el = document.createElement('div');
    this.el.id = 'navigation';
    this.append();
  }

  append() {
    this._slider.getRoot().appendChild(this.el);
  }
}
